import React, { PureComponent } from "react";
import { connect } from "react-redux";
import RadioButtonListFilter from "../../components/filters/RadioButtonListFilter";
import { updateFilter } from "../../actions/filter";
import { withTranslation } from "react-i18next";
import { CONTRACT_TERMS } from "../../constants/contractTerms";
import { updateHasChangedFilter } from "../../actions/componentStatus/hasChangedFilters";

const elementId = "ContractTerm";

class ContractTermFilterContainer extends PureComponent {
  render() {
    const { t, updateFilter } = this.props;

    try {
      return (
        <RadioButtonListFilter
          onChange={updateFilter}
          title={t("contractTermTitle")}
          value={this.contractTerm()}
          values={this.contractTerms()}
        />
      );
    } catch (e) {
      return null;
    }
  }

  contractTerm() {
    const { contractTermInMonths } = this.props;

    if (contractTermInMonths.length < 1) {
      return CONTRACT_TERMS[0].toString();
    } else {
      return contractTermInMonths[contractTermInMonths.length - 1].toString();
    }
  }

  contractTerms() {
    const { t } = this.props;

    return [
      [0, t("contractTermNoPreference")],
      [1, t("contractTermOneMonth")],
      [12, t("contractTermOneYear")],
      [24, t("contractTermTwoYears")]
    ];
  }
}

function mapStateToProps(state) {
  return {
    offerType: state.offerType,
    contractTermInMonths: state.filter[state.offerType].contractTermInMonths,
    hasChangedFilter: state.componentStatus.hasChangedFilters[elementId]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateFilter: (offerType, contractTermInMonths) => {
      dispatch(
        updateFilter(offerType, {
          contractTermInMonths: contractTermInMonths
        })
      );
    },
    updateHasChangedFilter: () => {
      dispatch(updateHasChangedFilter(elementId));
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { updateFilter, updateHasChangedFilter } = dispatchProps;
  const { offerType } = stateProps;

  return {
    ...stateProps,
    updateFilter: e => {
      const value = parseInt(e.target.value, 10);
      let newcontractTerms;

      if (value === CONTRACT_TERMS[0]) {
        newcontractTerms = [];
      } else {
        const valueIndex = CONTRACT_TERMS.indexOf(value);
        newcontractTerms = [
          ...new Set(CONTRACT_TERMS.slice(1, valueIndex + 1))
        ];
      }

      updateHasChangedFilter();
      updateFilter(offerType, newcontractTerms);
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withTranslation(["filters"])(ContractTermFilterContainer));
